import { isFunction as _isFunc } from 'lodash';
import { array, string } from 'prop-types';
import { compose, setPropTypes, withProps } from 'recompose';
import { MAP_FIELD } from '../constants';

const ButtonField = props => {
  const buttonFieldFactory = props.mapField[props.type];
  const buttonField = _isFunc(buttonFieldFactory)
    ? buttonFieldFactory(props)
    : null;

  return buttonField;
};

const buttonFieldPropTypes = {
  type: string.isRequired,
  pages: array.isRequired,
};

const enhanceButtonField = compose(
  setPropTypes(buttonFieldPropTypes),
  withProps(() => ({ mapField: MAP_FIELD })),
);

const ButtonFieldEnhanced = enhanceButtonField(ButtonField);

export default ButtonFieldEnhanced;
